/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_TitleInputs */

const en_history_title = /** @type {(inputs: History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History`)
};

const es_history_title = /** @type {(inputs: History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial`)
};

/**
* | output |
* | --- |
* | "History" |
*
* @param {History_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const history_title = /** @type {((inputs?: History_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_history_title(inputs)
	return es_history_title(inputs)
});